"use strict";

export const APP_NAME = '/';

export const CDN_PATH = server.cdnPath;

export const SECONDS_TO_SEND_OTP = server.otp.remaining_seconds_to_confirm_otp;
export const SECONDS_TO_RESEND_OTP = server.otp.remaining_seconds_to_resend_otp;
export const SECONDS_TO_SHOW_OTP_WARNING = server.otp.remaining_seconds_to_show_remaining_time;
export const OTP_TIME_EXPIRED = "Time expired, request a new OTP";

export const LINKS = server.links;

export const HEADER_MENU = server.headerMenu;

export const FORM_CONSTRAINTS = server.formConstraints;
export const REGEX_BTAG_ONLY_DIGITS = new RegExp(server.btagRegex);

export const PAGES = {
    FIRST_STEP: 'FIRST_STEP',
    SECOND_STEP: 'SECOND_STEP',
    SMS_STEP: 'SMS_STEP',
    COMPLETE_STEP: 'COMPLETE_STEP',
    SUCCESS: '/registration/registration/success',
    ERROR: '/registration/registration/error',
};

export const ActionConstants = {
    SET_IS_DESKTOP: "SET_IS_DESKTOP",
    UPDATE_CURRENT_PAGE: "UPDATE_CURRENT_PAGE",

    UPDATE_EMAIL_DATA_ACTION: "UPDATE_EMAIL_DATA_ACTION",
    UPDATE_FIRST_NAME_DATA_ACTION: "UPDATE_FIRST_NAME_DATA_ACTION",
    UPDATE_SURNAME_DATA_ACTION: "UPDATE_SURNAME_DATA_ACTION",
    UPDATE_BIRTHDAY_DATA_ACTION: "UPDATE_BIRTHDAY_DATA_ACTION",
    UPDATE_PROMOCODE_DATA_ACTION: "UPDATE_PROMOCODE_DATA_ACTION",
    VALIDATE_PROMOCODE: "VALIDATE_PROMOCODE",
    VALIDATE_PROMOCODE_SUCCESS: "VALIDATE_PROMOCODE_SUCCESS",
    VALIDATE_PROMOCODE_FAILURE: "VALIDATE_PROMOCODE_FAILURE",
    UPDATE_BTAG_AS_SITE_ID: "UPDATE_BTAG_AS_SITE_ID",
    RESET_PROMOCODE: "RESET_PROMOCODE",
    VALIDATE_STEP_1: "VALIDATE_STEP_1",
    VALIDATE_STEP_1_SUCCESS: "VALIDATE_STEP_1_SUCCESS",
    VALIDATE_STEP_1_FAILURE: "VALIDATE_STEP_1_FAILURE",

    GET_STATES: "GET_STATES",
    GET_STATES_SUCCESS: "GET_STATES_SUCCESS",
    GET_STATES_FAILURE: "GET_STATES_FAILURE",
    UPDATE_USERNAME_DATA_ACTION: "UPDATE_USERNAME_DATA_ACTION",
    UPDATE_PASSWORD_DATA_ACTION: "UPDATE_PASSWORD_DATA_ACTION",
    UPDATE_STATE_DATA_ACTION: "UPDATE_STATE_DATA_ACTION",
    UPDATE_PHONE_DATA_ACTION: "UPDATE_PHONE_DATA_ACTION",
    VALIDATE_STEP_2: "VALIDATE_STEP_2",
    VALIDATE_STEP_2_SUCCESS: "VALIDATE_STEP_2_SUCCESS",
    VALIDATE_STEP_2_FAILURE: "VALIDATE_STEP_2_FAILURE",

    RESEND_VERIFICATION_SMS_ACTION: "RESEND_VERIFICATION_SMS_ACTION",
    RESEND_VERIFICATION_SMS_ACTION_SUCCESS: "RESEND_VERIFICATION_SMS_ACTION_SUCCESS",
    RESEND_VERIFICATION_SMS_ACTION_FAILURE: "RESEND_VERIFICATION_SMS_ACTION_FAILURE",

    UPDATE_OTP_MESSAGE_ACTION: "UPDATE_OTP_MESSAGE_ACTION",
    UPDATE_OTP_COUNTDOWN_MESSAGE_ACTION: "UPDATE_OTP_COUNTDOWN_MESSAGE_ACTION",
    UPDATE_OTP_EXPIRED_TIME_ACTION: "UPDATE_OTP_EXPIRED_TIME_ACTION",

    SET_RESEND_OTP_AVAILABLE: "SET_RESEND_OTP_AVAILABLE",

    CREATE_ACCOUNT_ACTION: "CREATE_ACCOUNT_ACTION",
    CREATE_ACCOUNT_ACTION_SUCCESS: "CREATE_ACCOUNT_ACTION_SUCCESS",
    CREATE_ACCOUNT_ACTION_FAILURE: "CREATE_ACCOUNT_ACTION_FAILURE",

    UPDATE_GTM_REGISTRATION_FIRST_INTERACTION_SENT: "UPDATE_GTM_REGISTRATION_FIRST_INTERACTION_SENT",
    UPDATE_GTM_REGISTRATION_SUCCESS_SENT: "UPDATE_GTM_REGISTRATION_SUCCESS_SENT",
}

export const ApiConstants = {
    URI_FE: server.ajaxEndpoints.uri,
    API_VALIDATE_PROMOCODE: server.ajaxEndpoints.validatePromocode.uri,
    API_VALIDATE_STEP_1: server.ajaxEndpoints.validateStep1.uri,
    API_VALIDATE_STEP_2: server.ajaxEndpoints.validateStep2.uri,
    API_GET_STATES: server.ajaxEndpoints.getStates.uri,
    API_RESEND_VERIFICATION_SMS: server.ajaxEndpoints.resendVerificationSms.uri,
    API_CREATE_ACCOUNT: server.ajaxEndpoints.createAccount.uri,
};

export const PHONE_NUMBER_LENGTH = 10;
export const PIN_NUMBER_LENGTH = 4;

export const DOMAIN = window.location.hostname.split(window.location.hostname.split('.')[0])[1];

export const COOKIES = {
    BTAG: 'btag',
    PROMOCODE: 'promocode',
    REG_QUERY_URI: 'regQueryString',
};

export const REGEX_ONLY_LETTERS = /^[a-zA-Z]+$/;

export const REGEX_ONLY_LETTERS_AND_NUMBERS = /^[0-9a-zA-Z]+$/;